
import { PageHeader } from "@/components/PageHeader";
import { useActions } from "@/hooks/useActions";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ListTodo } from "lucide-react";

const Tasks = () => {
	const { data: tasks, isLoading } = useActions("Task");

	if (isLoading) {
		return <div>Loading tasks...</div>;
	}

	return (
		<div>
			<PageHeader title="Tasks" />
			<div className="grid gap-4">
				{tasks?.map((task) => (
					<Card key={task.id}>
						<CardHeader>
							<CardTitle className="text-lg">{task.name}</CardTitle>
						</CardHeader>
						<CardContent>
							<p className="text-gray-600">{task.description}</p>
							<div className="flex items-center mt-2 text-sm text-gray-500">
								<ListTodo className="w-4 h-4 mr-1" />
								<span>
									{new Date(task.created_at).toLocaleDateString()}
								</span>
							</div>
						</CardContent>
					</Card>
				))}
			</div>
		</div>
	);
};

export default Tasks;
